export default __webpack_public_path__ + "static/media/01 Marketing - Floor Plan by Type 2.9ed99578.jpeg";